// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAstkgho } from "../../../icons/mono/build/icon-astkgho.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AstkghoIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAstkgho.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AstkghoIcon.displayName = 'AstkghoIcon';
}

export default AstkghoIcon;